var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import client from "@irati/utils/services/apollo";
import PBService from "@irati/utils/services";
import listFormat from "@irati/utils/services/graph/utils/listFormat";
import tagQuery, { tagKey } from "./queries/getTag";
import tagsQuery, { tagsKey } from "./queries/listTags";
import createTagMutation, { createTagKey } from "./mutation/createTag";
import updateTagMutation, { updateTagKey } from "./mutation/updateTag";
var TagService = /** @class */ (function (_super) {
    __extends(TagService, _super);
    function TagService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TagService.prototype.get = function (_a, options) {
        var id = _a.id, _b = _a.withChildren, withChildren = _b === void 0 ? false : _b;
        if (options === void 0) { options = {}; }
        var variables = { id: id, withChildren: withChildren };
        return client.query(__assign(__assign({}, options), { query: tagQuery, variables: variables })).then(function (_a) {
            var data = _a.data;
            return data[tagKey];
        });
    };
    TagService.prototype.list = function (_a, options) {
        if (options === void 0) { options = {}; }
        var _b = _a.withChildren, withChildren = _b === void 0 ? false : _b, args = __rest(_a, ["withChildren"]);
        var variables = __assign(__assign({}, args), { withChildren: withChildren });
        return client.query(__assign(__assign({}, options), { query: tagsQuery, variables: variables })).then(function (_a) {
            var data = _a.data;
            return listFormat(data[tagsKey]);
        });
    };
    TagService.prototype.create = function (_a, options) {
        var _b = _a.withChildren, withChildren = _b === void 0 ? false : _b, data = _a.data;
        if (options === void 0) { options = {}; }
        var variables = { data: data, withChildren: withChildren };
        return client.mutate(__assign(__assign({}, options), { mutation: createTagMutation, variables: variables })).then(function (res) { return res.data[createTagKey]; });
    };
    TagService.prototype.update = function (_a, options) {
        var _b = _a.withChildren, withChildren = _b === void 0 ? false : _b, data = _a.data;
        if (options === void 0) { options = {}; }
        var variables = { data: data, withChildren: withChildren };
        return client.mutate(__assign(__assign({}, options), { mutation: updateTagMutation, variables: variables })).then(function (res) { return res.data[updateTagKey]; });
    };
    return TagService;
}(PBService));
export default new TagService({ errorHandlers: [] });
